var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('b-container',{staticClass:"modal-page d-flex justify-content-center"},[_c('verification-form',{staticClass:"modal__card",attrs:{"to":_vm.$route.params.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }